export default __webpack_public_path__ + "img/a5cdf63971f050160a164caa7dff726b.png";